import React from 'react';
import './Contact.css';
import Address from '../Address/Address';


const Contact=() => {
 
  return (
    <div className='contact-div' id='contact'>
        <h3>Contact</h3>
        <div className='text-section'>
          <span className='spantext'>I Want To Hear From You!</span>
          <p>I would love to work with you so why are you waiting for. Drop me a line and let’s start working together! Please fill out the form below to get in touch with me or request for a quote here. I’ll promise to get back to you shortly</p>
        </div>
        <div className='sub-div'>
            <div className='address-div'>
              <Address icon='fa-sharp fa-solid fa-location-dot' h4='Adress' span2='Central Province, Srilanka.' bg='a' color='a' name='Address'></Address>
              <Address icon='fa-solid fa-envelope' h4='Email' span2='hakeemfowmi10@gmail.com' bg='c' color='c' name='Email' href='mailto:hakeemfowmi10@gmail.com'></Address>
              <Address icon='fa-solid fa-phone' h4='Phone' span2='+94 77-251-1686' bg='b' color='b' name='Phone' href='https://wa.me/+94772511686'></Address>
            </div>
            <div className='form-div'>
              <form action="https://formspree.io/f/mrgdvava" method="POST">
                <div className='form-box'>
                  <input id='textInput' type='text' placeholder='Name' name='name' />
                  <input id='textInput' type='tel' placeholder='Number' name='number' />
                </div>
                <div className='form-box'>
                  <input id='textInput' type='email' placeholder='Email' name='email' />
                  <input id='textInput' type='text' placeholder='Subject' name='subject' />
                </div>
                <div className='form-box'>
                  <textarea id='textInput' cols='30' rows='7' placeholder='Text here...' name='text' />
                </div>
                <div className='form-box'>
                  <button className='btn' type='submit'>Submit</button>
                </div>
              </form>
            </div>
        </div>       
    </div>
  )
}

export default Contact;